import { render, staticRenderFns } from "./yc-sales.vue?vue&type=template&id=057774a4&scoped=true&"
import script from "./yc-sales.vue?vue&type=script&lang=js&"
export * from "./yc-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057774a4",
  null
  
)

export default component.exports